import(/* webpackMode: "eager", webpackExports: ["SmoothProvider"] */ "/vercel/path0/app/context/ScrollSmootherProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/layout/AnalyticsWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/layout/footer/FooterWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/layout/PerformanceProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/shared/navigation/NavBar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/builder-registry.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/css/global.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"app/ui/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"../fonts/Montserrat/Montserrat-VF.woff2\",\"weight\":\"100 900\",\"style\":\"normal\",\"variable\":\"--font-montserrat\"}],\"variableName\":\"montserratVariable\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"app/ui/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"../fonts/Montserrat/Montserrat-Italic-VF.woff2\",\"weight\":\"100 900\",\"style\":\"italic\",\"variable\":\"--font-montserrat-italic\"}],\"variableName\":\"montserratItalicVariable\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/css/hover.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/css/icomoon.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/css/icons.css");
